if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  document.addEventListener('DOMContentLoaded', function () {
    document.body.addEventListener('click', function (e) {
      const quickViewBtn = e.target.closest('[bss-b2b-btn-quickview]');
      if (quickViewBtn) {
        setTimeout(() => {
          document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
        }, 2000);
      }
    });
  });

  setTimeout(() => {
    const isPDP = window.location.pathname.includes("/products/");
    if (isPDP) {
        let oldHref = location.href;
        new MutationObserver(() => {
            if (oldHref !== location.href) {
                oldHref = location.href;
                const variant = new URL(location.href).searchParams.get('variant');
                setTimeout(() => {
                    const productForm = document.querySelector("[bss-b2b-main-product-form]");
                    BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
                        productForm
                    });
                }, 600)
            }
        }).observe(document, {
            subtree: true,
            childList: true
        });
    } 
  }, 3000);
}

